import React from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const GenericPdfDownloader = ({ rootElementId, downloadFileName }) => {
  const downloadPdfDocument = async () => {
    const input = document.getElementById(rootElementId);
    if (!input) return;

    // Wait for all images to finish loading
    const images = input.querySelectorAll("img");
     console.log("Images found:", images.length);
    await Promise.all(
    Array.from(images).map((img) => {
      return new Promise((resolve) => {
        // Skip if already base64
        if (img.src.startsWith("data:")) return resolve();

        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const tempImg = new Image();
        tempImg.crossOrigin = "anonymous";

        tempImg.onload = () => {
          canvas.width = tempImg.naturalWidth;
          canvas.height = tempImg.naturalHeight;
          ctx.drawImage(tempImg, 0, 0);
          try {
            img.src = canvas.toDataURL("image/jpeg", 0.8); // ✅ replace src with base64
          } catch {
            // CORS failed even with anonymous — leave as-is
          }
          resolve();
        };

        tempImg.onerror = () => resolve(); // skip broken images
        tempImg.src = img.src + "?t=" + Date.now(); // cache-bust to force fresh fetch with CORS header
      });
    })
  );

    const canvas = await html2canvas(input, {
      useCORS: true,
      scale: 2,           // sharper output
      backgroundColor: "#ffffff",
    });

    const imgData = canvas.toDataURL("image/jpeg", 1.0);

    const pdf = new jsPDF("p", "mm", "a4");

    const pageWidth  = pdf.internal.pageSize.getWidth();   // 210 mm
    const pageHeight = pdf.internal.pageSize.getHeight();  // 297 mm
    const margin     = 10;
    const printWidth = pageWidth - margin * 2;             // 190 mm

    // Scale canvas height to match the printed width
    const imgHeightMM = (canvas.height * printWidth) / canvas.width;

    let remainingHeight = imgHeightMM;
    let sourceY = 0; // y offset (in mm) into the image we've already printed

    while (remainingHeight > 0) {
      const sliceHeight = Math.min(remainingHeight, pageHeight - margin * 2);
      pdf.addImage(
        imgData,
        "JPEG",
        margin,
        margin,
        printWidth,
        imgHeightMM,   // full image height — PDF clips to page automatically
        undefined,
        "FAST",
        0
      );

      remainingHeight -= (pageHeight - margin * 2);
      sourceY         += (pageHeight - margin * 2);

      if (remainingHeight > 0) {
        pdf.addPage();
      }
    }

    pdf.save(`${downloadFileName}.pdf`);
  };

  return (
    <button
      className="btn btn-default align-self-center d-none d-md-flex no-print"
      style={{
        color: "#1782F4",
        borderRadius: "5px",
        background: "#fff",
      }}
      onClick={downloadPdfDocument}
    >
      <strong>Print PDF</strong>
    </button>
  );
};

export default GenericPdfDownloader;


// import React from "react";
// import html2canvas from "html2canvas";
// import jsPDF from "jspdf";

// // Helper: fetch an image and convert it to a base64 data URL
// const toDataURL = (url) =>
//   fetch(url, { mode: "cors" })
//     .then((res) => res.blob())
//     .then(
//       (blob) =>
//         new Promise((resolve, reject) => {
//           const reader = new FileReader();
//           reader.onloadend = () => resolve(reader.result);
//           reader.onerror = reject;
//           reader.readAsDataURL(blob);
//         })
//     )
//     .catch(() => null); // return null if fetch fails (e.g. opaque cross-origin)

// const GenericPdfDownloader = ({ rootElementId, downloadFileName }) => {
//   const downloadPdfDocument = async () => {
//     const input = document.getElementById(rootElementId);
//     if (!input) return;

//     // ── Step 1: Replace every <img> src with an inline base64 data URL ──────
//     const images = Array.from(input.querySelectorAll("img"));
//     const origSrcs = [];

//     await Promise.all(
//       images.map(async (img, i) => {
//         origSrcs[i] = img.src; // remember original src

//         // Skip if already a data URL or blob URL
//         if (img.src.startsWith("data:") || img.src.startsWith("blob:")) return;

//         const dataUrl = await toDataURL(img.src);
//         if (dataUrl) {
//           img.src = dataUrl; // swap to inline – no CORS problem
//           // Wait for the browser to re-render it
//           await new Promise((resolve) => {
//             if (img.complete && img.naturalWidth) return resolve();
//             img.onload = resolve;
//             img.onerror = resolve;
//           });
//         }
//       })
//     );

//     // ── Step 2: Capture with html2canvas ────────────────────────────────────
//     const canvas = await html2canvas(input, {
//       useCORS: true,       // still useful for any images we couldn't pre-fetch
//       allowTaint: false,   // must be false when useCORS is true
//       scale: 2,
//       backgroundColor: "#ffffff",
//       logging: false,
//       imageTimeout: 15000,
//       onclone: (clonedDoc) => {
//         // Make sure nothing is hidden in the clone
//         const clonedEl = clonedDoc.getElementById(rootElementId);
//         if (clonedEl) {
//           clonedEl.style.overflow = "visible";
//           clonedEl.style.height = "auto";
//         }
//       },
//     });

//     // ── Step 3: Restore original <img> srcs ─────────────────────────────────
//     images.forEach((img, i) => {
//       img.src = origSrcs[i];
//     });

//     // ── Step 4: Build the PDF (multi-page safe) ──────────────────────────────
//     const imgData = canvas.toDataURL("image/jpeg", 1.0);
//     const pdf = new jsPDF("p", "mm", "a4");

//     const pageWidth  = pdf.internal.pageSize.getWidth();  // 210 mm
//     const pageHeight = pdf.internal.pageSize.getHeight(); // 297 mm
//     const margin     = 10;
//     const printWidth = pageWidth - margin * 2;            // 190 mm

//     const pxPerMM    = canvas.width / printWidth;         // pixels per mm
//     const pageHeightPx = (pageHeight - margin * 2) * pxPerMM;
//     const totalHeightMM = (canvas.height / canvas.width) * printWidth;

//     let pageCount = 0;
//     let yOffsetPx = 0;

//     while (yOffsetPx < canvas.height) {
//       if (pageCount > 0) pdf.addPage();

//       // Slice the canvas vertically for each page
//       const sliceCanvas = document.createElement("canvas");
//       sliceCanvas.width  = canvas.width;
//       sliceCanvas.height = Math.min(pageHeightPx, canvas.height - yOffsetPx);

//       const ctx = sliceCanvas.getContext("2d");
//       ctx.drawImage(
//         canvas,
//         0, yOffsetPx,                    // source x, y
//         canvas.width, sliceCanvas.height, // source w, h
//         0, 0,                             // dest x, y
//         canvas.width, sliceCanvas.height  // dest w, h
//       );

//       const sliceData   = sliceCanvas.toDataURL("image/jpeg", 1.0);
//       const sliceHeightMM = (sliceCanvas.height / pxPerMM);

//       pdf.addImage(sliceData, "JPEG", margin, margin, printWidth, sliceHeightMM);

//       yOffsetPx += pageHeightPx;
//       pageCount++;
//     }

//     pdf.save(`${downloadFileName}.pdf`);
//   };

//   return (
//     <button
//       className="btn btn-default align-self-center d-none d-md-flex no-print"
//       style={{ color: "#1782F4", borderRadius: "5px", background: "#fff" }}
//       onClick={downloadPdfDocument}
//     >
//       <strong>Print PDF</strong>
//     </button>
//   );
// };

// export default GenericPdfDownloader;